<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>CREER UN PROBLEME</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="$emit('closeSidebar')"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <form>
          <template>
            <p class="mt-5">Client <b style="color: #ff6141">*</b></p>
            <v-select
              :reduce="(rep) => rep.id"
              class="w-full"
              label="social_reason"
              v-model="form.customer_id"
              :options="customers"
            ></v-select>
          </template>

          <p class="mt-5">Libellé <b style="color: #ff6141">*</b></p>
          <vs-input
            autocomplete="off"
            v-on:keydown.enter.prevent="keyEvent($event)"
            v-model="form.title"
            class="w-full"
            name="item-name"
          />

          <p class="mt-5">Département <b style="color: #ff6141">*</b></p>
          <v-select
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="form.departement_id"
            :options="departements"
          ></v-select>

          <p v-if="form.customer_id && form.departement_id" class="mt-5">
            Service <b style="color: #ff6141">*</b>
          </p>

          <v-select
            v-if="form.customer_id && form.departement_id"
            :reduce="(rep) => rep.id"
            class="w-full"
            label="name"
            v-model="form.service_id"
            :options="services"
          ></v-select>

          <p class="mt-5">Incidents <b style="color: #ff6141">*</b></p>
          <v-select multiple
            :reduce="(rep) => rep.id"
            class="w-full"
            label="ref"
            v-model="incident_list"
            :options="incidents"
          ></v-select>
        </form>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submit()" :disabled="!isFormValid"
        >Soumettre</vs-button
      >
      <vs-button type="border" color="danger" @click="$emit('closeSidebar')"
        >Annuler</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
let base_self;
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "addSidebar",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    addCallBack: {
      type: Function,
    },
    getServices: { type: Function },
    getIncidents: { type: Function },
    customers: { type: Array, required: true },
    departements: { type: Array, required: true },
    services: { type: Array, required: true },
    incidents: { type: Array, required: true },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
    },
    "form.departement_id": () => {
      base_self.form.service_id = "";
      base_self.getServices(
        base_self.form.customer_id,
        base_self.form.departement_id
      );
    },
    "form.service_id": (val) => {
      base_self.incident_list = [];
      base_self.getIncidents(
        base_self.form.customer_id,
        base_self.form.departement_id,
        val
      );
    },
  },
  data() {
    return {
      popupActive: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      form: {
        customer_id: "",
        title: "",
        departement_id: "",
        service_id: "",
      },
      incident_list: [],
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        if (this.isSidebarActive) {
          Object.keys(this.form).forEach((index) => (this.form[index] = ""));
        }
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      var is_valide = true;
      if (!this.form.customer_id || this.form.customer_id === "")
        is_valide = false;
      if (!this.form.title || this.form.title === "") is_valide = false;
      if (!this.form.departement_id || this.form.departement_id === "")
        is_valide = false;
      if (!this.form.service_id || this.form.service_id === "")
        is_valide = false;
      if (this.incident_list.length <= 0) is_valide = false;

      return is_valide;
    },
  },
  methods: {
    keyEvent(event) {
      if (event) event.preventDefault();
    },
    submit() {
      this.$vs.loading();

      let formData = new FormData();
      formData.append("title", this.form.title);
      formData.append("customer_id", this.form.customer_id);
      formData.append("departement_id", this.form.departement_id);
      formData.append("service_id", this.form.service_id);
      for (let i = 0; i < this.incident_list.length; i++) {
        let item = this.incident_list[i];
        formData.append("incidents[" + i + "]", item);
      }

      this.$http
        .post("/problems/store", formData)
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.status == true) {
            this.$vs.notify({
              title: "Succès",
              text: "Opération effectuée avec succès",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$emit("closeSidebar");
            this.addCallBack(this.form);
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error && error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
  mounted() {
    base_self = this;
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
